import "@hotwired/turbo-rails";
import "controllers/companies";
import $ from "jquery";
import "@popperjs/core";
import "bootstrap";
import * as bootstrap from "bootstrap";
import "@fortawesome/fontawesome-free/js/all";
import "select2/dist/js/select2.js";

window.bootstrap = bootstrap; // Optional: Attach to window for global access
window.jQuery = $;
window.$ = $;

require("@nathanvda/cocoon")
require("./company/jquery.cookie");
require("./company/misc");
require("./company/dashboard");

console.log("Company is working!");
